module.exports = __webpack_public_path__ + "static/media/lfz-logo.e24d8fa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/lfz-logo.png
// module id = 403
// module chunks = 1